import { track } from "@/lib/analytics";
import { useState } from "react";
import { PillLink } from "@/components/site/Buttons";
import { Chips, FormError, Honeypot, SentPanel, TextArea, TextInput, useEnquiry } from "@/components/forms/fields";
import { FOCUS_AREAS, PARTNER_TYPES } from "@/content/partners";

const EMPTY = { name: "", email: "", organisation: "", title: "", partner_type: "", focus_areas: [], website: "", message: "", hp: "" };

export const PartnerForm = () => {
  const [f, setF] = useState(EMPTY);
  const [localErr, setLocalErr] = useState("");
  const { status, reference, error, submit, reset } = useEnquiry("/enquiries/partner");
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));

  const invalid = (message) => { track("partner_validation_error"); setLocalErr(message); };
  const onSubmit = (e) => {
    e.preventDefault();
    if (!f.partner_type) return invalid("Choose the option that best describes your organisation.");
    if (f.message.trim().length < 10) return invalid("Tell us a little more about what you've built (10+ characters).");
    setLocalErr("");
    return submit(f);
  };

  if (status === "sent") return <SentPanel reference={reference} onReset={() => { setF(EMPTY); reset(); }} testId="partner-form-success" />;

  return (
    <form data-clarity-mask="true" data-analytics-form="partner" onSubmit={onSubmit} className="relative space-y-9" data-testid="partner-form" noValidate={false}>
      <Honeypot value={f.hp} onChange={set("hp")} />
      <div className="grid gap-8 sm:grid-cols-2">
        <TextInput label="Your name" required value={f.name} onChange={set("name")} autoComplete="name" maxLength={120} testId="partner-name-input" />
        <TextInput label="Work email" type="email" required value={f.email} onChange={set("email")} autoComplete="email" testId="partner-email-input" />
        <TextInput label="Organisation" required value={f.organisation} onChange={set("organisation")} autoComplete="organization" maxLength={160} testId="partner-organisation-input" />
        <TextInput label="Your role" value={f.title} onChange={set("title")} autoComplete="organization-title" maxLength={120} testId="partner-title-input" />
      </div>
      <Chips label="We are a" required options={PARTNER_TYPES} value={f.partner_type} onChange={set("partner_type")} testIdPrefix="partner-type" />
      <Chips label="Where could you help?" multi options={FOCUS_AREAS} value={f.focus_areas} onChange={set("focus_areas")} testIdPrefix="partner-area" />
      <TextInput label="Website" hint="Optional" value={f.website} onChange={set("website")} placeholder="https://" maxLength={300} testId="partner-website-input" />
      <TextArea label="What have you built, and which part of the problem does it solve?" required value={f.message} onChange={set("message")} maxLength={5000} rows={6} testId="partner-message-input" />
      {localErr && <p className="text-[14px] text-caution" data-testid="partner-form-validation">{localErr}</p>}
      <FormError message={error} testId="partner-form-error" />
      <div className="flex flex-wrap items-center gap-5">
        <PillLink type="submit" disabled={status === "sending"} testId="partner-submit-button">{status === "sending" ? "Sending…" : "Send to the founders"}</PillLink>
        <p className="text-[13px] text-fg-3">Goes straight to the founders' inbox.</p>
      </div>
    </form>
  );
};
